module.exports = __webpack_public_path__ + "/994835115bb2cdc90183431535516e75.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/assets/arrow_2.png
 ** module id = 935
 ** module chunks = 0
 **/